import {AxiosResponse} from 'axios'
import { ID, Response } from '../../_dashboard/helpers'
import { CommonQueryResponse } from './common_types'
import dataAxios from '../modules/auth/core/dataAxios'

const API_URL = process.env.REACT_APP_API_URL|| ''
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig';

const ls = localStorage.getItem(I18N_CONFIG_KEY) || '{"selectedLang":"fr"}'; // Récupère la valeur de localStorage
const config = JSON.parse(ls); // Convertit la chaîne JSON en objet
const selectedLang = config.selectedLang;
interface DeleteResponse {
  payload?: {
    code?: number;
  };
}
const getAll = (query: any, URL: string): Promise<any> => {
  return dataAxios
    .get(`${API_URL + URL}`, { params: { ...query } })

    .then((d: any) => { return d.data })
}

const getOneById = (id: ID,URL:String): Promise<any | undefined> => {
  return dataAxios
    .get(`${API_URL+URL}/${id}`, {
  params: { language: selectedLang }, // Ajoute le paramètre language à l'URL
    })
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}
const getOneByIdbylang = (URL:String): Promise<any | undefined> => {
  return dataAxios
    .get(`${API_URL+URL}`, {
    })
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}

const createOne = (user: any,URL:String): Promise<any | undefined> => {
  return dataAxios
    .post(API_URL+URL, user)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
}

const updateOne = (user: any,URL:String): Promise<any | undefined> => {
  return dataAxios
    .patch(`${API_URL+URL}`, user)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
}
const patchOne = (user: any,URL:String): Promise<any | undefined> => {
  return dataAxios
    .patch(`${API_URL+URL}`, user)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response)
}

const updatewithtranslation = (user: any,URL:String): Promise<any | undefined> => {
  return dataAxios
    .patch(`${API_URL+URL}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: Response<any>) => response.data)
}

const deleteOne = (userId: ID, URL: string): Promise<DeleteResponse> => {
  return dataAxios
    .delete(`${API_URL + URL}/${userId}`)
    .then((response: AxiosResponse<DeleteResponse>) => response.data)
}

const deleteSelectedOne = (userIds: Array<ID>, URL: string): Promise<void> => {
  return Promise.all(
    userIds.map((id) => dataAxios.delete(`${API_URL + URL}/${id}`))
  ).then(() => undefined)
}

export {getAll, deleteOne, deleteSelectedOne, getOneById, createOne, updateOne, patchOne,updatewithtranslation,getOneByIdbylang}
